export const RECAPTCHA_SITE_KEY = '6LeHEeUcAAAAAFsVnCRMWstK0fHaOhHsh2OfkLTw';
export const PLAY_STORE_APP_LINK =
  'https://play.google.com/store/apps/details?id=com.porter.ion_porter';
export const APPLE_STORE_APP_LINK = 'https://apps.apple.com/us/app/your-porter/id1032870693';
export const TERMS_AND_CONDITIONS_LINK = 'https://hosts.guesty.com/terms-and-conditions';
export const PRIVACY_POLICY_LINK = 'https://privacy.guesty.com/';
